export const MOBO_PAGES = ['flows', 'steps', 'actions'];
